import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import { useParams } from 'react-router-dom';

import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";

import Header from "./components/header/Header";
import Article from "./components/article/Article";
import OtherArticles from "../../components/other-articles/OtherArticles";
import RequestModal from "../../components/modal/RequestModal";

import {
    useLazyGetArticleQuery, useLazyGetArticlesQuery, useLazyGetTagsQuery
} from "../../api/blog";

import styles from "./BlogPage.module.scss";
import {CircularProgress} from "@mui/material";

function BlogPage() {

    const { slug } = useParams();

    const [ articleRequest, { data: articles, isLoading } ] = useLazyGetArticleQuery()

    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    const [open, setOpen] = React.useState(false);

    const [ articlesRequest, { data: otherArticles } ] = useLazyGetArticlesQuery()

    const [ tagsRequest, { data: tags } ] = useLazyGetTagsQuery()

    const handleOpen = () => setOpen(true);

    const handleClose = () => setOpen(false);

    useEffect(() => {
        articleRequest({slug});
        }, [articleRequest, slug]);

    useEffect(() => {
        articlesRequest({});
        tagsRequest({});
    }, [articlesRequest, tagsRequest]);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const article = articles?.data?.[0];

    return (
        <>
            <div className={styles.blogPage}>
                <Header handleOpen={handleOpen} title={article?.title}/>
                {(isLoading || !article) && <div className={styles.loaderContainer}>
                    <CircularProgress size={isMobile ? 24 : 40} />
                </div>}
                <Article article={article} />
                <div className={styles.otherArticles}>
                    <Container>
                        <div className={styles.otherArticlesContainer}>
                            <Row>
                                <Col xxl={8} className='p-0'>
                                    <h1 className={styles.title}>
                                        Другие статьи
                                    </h1>
                                    <div className={styles.articles}>
                                        <OtherArticles articles={otherArticles?.data.slice(0, 5)}
                                                       tags={tags?.data}/>
                                    </div>
                                    <Link to='/blog' className={styles.textLink}>Читать все статьи</Link>
                                </Col>
                            </Row>
                        </div>
                    </Container>
                </div>
                <Row>
                    <Col xs={12} className='p-0'>
                        <h5 className={styles.companyName}>© 2026 Вэдмаркет</h5>
                    </Col>
                </Row>
            </div>
            <RequestModal open={open} handleClose={handleClose}/>
        </>
    );
}

export default BlogPage
